/**
 * R 인증번호 조회
 * @param r_number SearchRNumberQueryDTO
 * @returns Promise<GetProtectionByRNumberResponseDTO>
 */ export class GetProtectionByRNumberCommand {
    execute(param) {
        let { r_number  } = param;
        const url = "/protection";
        const params = new URLSearchParams();
        params.append("r_number", r_number);
        return this.apiService.fetch(url, {
            params
        }).then((res)=>res.data);
    }
    constructor(apiService){
        this.apiService = apiService;
    }
}
